import loadable from '@loadable/component';

export const OrgDashboardGradFairsHomeContainerLoadable = loadable(
  () => import('./OrgDashboardGradFairsHomeContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardGradFairsHomeContainer,
  },
);
